import React from 'react';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import SessionMonitor from './components/SessionMonitor';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

const App = () => {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <BaseOptionChartStyle />
      <SessionMonitor />
      <Router />
    </ThemeProvider>
  );
}

export default App
